// src/components/CreatePullRequest.js

import React, { useState } from "react";
import {
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Box,
  useTheme,
  Tooltip,
} from "@mui/material";
import { CallMerge as CallMergeIcon } from "@mui/icons-material";

const CreatePullRequest = ({ token, onSuccess, onError, mergedCode, acceptedChanges, issueKey, projectId, fileName }) => {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const theme = useTheme();

  const commitCode = async (filePath) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github/commit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          project_id: projectId,
          issue_key: issueKey,
          body: {
            [filePath]: mergedCode
          }
        }),
      });
  
      if (!response.ok) {
        throw new Error(`Commit failed: ${response.statusText}`);
      }
  
      const data = await response.json();
      console.log('Commit successful:', data);
      return data;
    } catch (error) {
      console.error('Error committing code:', error);
      throw error;
    }
  };

  const markIssueSolved = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/platform/sonarqube/mark-issue-solved?issue_key=${issueKey}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({
            search_all_pages: true
          }),
        }
      );

      if (!response.ok) {
        console.error('Failed to mark issue as solved');
      } else {
        console.log('Issue marked as solved successfully');
      }
    } catch (error) {
      console.error('Error marking issue as solved:', error);
    }
  };

  const handleCreatePR = async () => {
    try {
      if (!token) {
        const errorMessage = 'Authentication token is required';
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
        if (onError && typeof onError === 'function') {
          onError(errorMessage);
        }
        return;
      }
  
      setLoading(true);
      
      // Step 1: Commit the code changes
      try {
        // You'll need to pass the file path as a prop or derive it from fileName
        const filePath = fileName || 'src/main.js'; // Default fallback
        await commitCode(filePath);
      } catch (commitError) {
        const errorMessage = `Failed to commit code: ${commitError.message}`;
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
        if (onError && typeof onError === 'function') {
          onError(errorMessage);
        }
        return;
      }
      
      // Step 2: Create Pull Request
      const response = await fetch(`${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/github/create-pr`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          "project_id": projectId,
          "title": "AI Auto Fix - Code Quality Improvement",
          "body": mergedCode || "This PR contains automated code quality improvements",
          "draft": false,
          "branch": "main"
        }),
      });
  
      if (response.ok) {
        const data = await response.json();
        const successMessage = 'Pull Request created successfully!';
        
        setSnackbar({
          open: true,
          message: successMessage,
          severity: 'success'
        });
        
        console.log('Create PR Response:', data);
        
        // Call mark issue solved API and wait for it to complete
        if (issueKey) {
          await markIssueSolved();
        }
        
        // Only call onSuccess after marking issue as solved is complete
        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(data);
        }
        
      } else {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch (jsonError) {
          console.error('Error parsing error response:', jsonError);
        }
        
        const errorMessage = `Failed to create Pull Request: ${errorData.message || response.statusText || 'Unknown error'}`;
        
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
        
        if (onError && typeof onError === 'function') {
          onError(errorMessage);
        }
      }
    } catch (error) {
      console.error('Error creating Pull Request:', error);
      const errorMessage = `Failed to create Pull Request: ${error.message || 'Network error'}`;
      
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
      
      if (onError && typeof onError === 'function') {
        onError(errorMessage);
      }
    } finally {
      setLoading(false);
    }
  };

//   const handleCreatePR = async () => {
//     try {
//       if (!token) {
//         const errorMessage = 'Authentication token is required';
//         setSnackbar({
//           open: true,
//           message: errorMessage,
//           severity: 'error'
//         });
//         if (onError && typeof onError === 'function') {
//           onError(errorMessage);
//         }
//         return;
//       }

//       setLoading(true);
      
//       const response = await fetch('https://g23i2ede0i.execute-api.ap-south-1.amazonaws.com/dev/athrv/api/v1/github/create-pr', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`,
//         },
//         body: JSON.stringify({
//           "project_id": projectId,
//           "title": "AI Auto Fix - Code Quality Improvement",
//           "body": mergedCode || "This PR contains automated code quality improvements",
//           "draft": false,
//           "branch": "main"
//         }),
//       });

//       if (response.ok) {
//         const data = await response.json();
//         const successMessage = 'Pull Request created successfully!';
        
//         setSnackbar({
//           open: true,
//           message: successMessage,
//           severity: 'success'
//         });
        
//         console.log('Create PR Response:', data);
        
//         // Call mark issue solved API and wait for it to complete
//         if (issueKey) {
//           await markIssueSolved();
//         }
        
//         // Only call onSuccess after marking issue as solved is complete
//         if (onSuccess && typeof onSuccess === 'function') {
//           onSuccess(data);
//         }
        
//       } else {
//         let errorData = {};
//         try {
//           errorData = await response.json();
//         } catch (jsonError) {
//           console.error('Error parsing error response:', jsonError);
//         }
        
//         const errorMessage = `Failed to create Pull Request: ${errorData.message || response.statusText || 'Unknown error'}`;
        
//         setSnackbar({
//           open: true,
//           message: errorMessage,
//           severity: 'error'
//         });
        
//         if (onError && typeof onError === 'function') {
//           onError(errorMessage);
//         }
//       }
//     } catch (error) {
//       console.error('Error creating Pull Request:', error);
//       const errorMessage = `Failed to create Pull Request: ${error.message || 'Network error'}`;
      
//       setSnackbar({
//         open: true,
//         message: errorMessage,
//         severity: 'error'
//       });
      
//       if (onError && typeof onError === 'function') {
//         onError(errorMessage);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };





  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Button
          variant="contained"
          onClick={handleCreatePR}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <CallMergeIcon />}
          sx={{
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
            "&:hover": {
              backgroundColor: theme.palette.success.dark,
            },
            "&.Mui-disabled": {
              backgroundColor: theme.palette.mode === 'dark' 
                ? theme.palette.grey[700] 
                : theme.palette.grey[300],
              color: theme.palette.mode === 'dark' 
                ? theme.palette.grey[500] 
                : theme.palette.grey[600],
            },
            minWidth: '160px',
          }}
        >
          {loading ? 'Creating PR...' : 'Create Pull Request'}
        </Button>
        
        {!loading && (
          <Tooltip
            title="Create a Pull Request with the fixed code"
            placement="left"
            arrow
          >
            <CallMergeIcon
              sx={{
                color: theme.palette.mode === 'dark' 
                  ? theme.palette.grey[400] 
                  : theme.palette.grey[500],
                fontSize: 20,
                cursor: "help",
              }}
            />
          </Tooltip>
        )}
      </Box>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleSnackbarClose} 
          severity={snackbar.severity}
          sx={{ 
            width: '100%',
            backgroundColor: theme.palette.mode === 'dark' 
              ? theme.palette.grey[800] 
              : undefined,
            color: theme.palette.mode === 'dark' 
              ? theme.palette.grey[100] 
              : undefined
          }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CreatePullRequest;